<h2 mat-dialog-title>{{dataDefId != null && dataDefId > 0 ? 'Edit' : 'Add'}} Code</h2>
<mat-dialog-content>
  <div style="display: flex; flex-direction: column; padding-bottom:10px; width:450px;">
    <form [formGroup]="dynamicFieldForm" *ngIf="dynamicFieldForm">
      <ng-container *ngFor="let field of displayFields; index as i">
        <div [ngSwitch]="field.ControlType">

          <!-- Textboxes (Number only) -->
          <tyl-form-field [label]='field.DisplayName' [fullWidth]='true' *ngSwitchCase="'numeric'">
            <input #input formControlName="{{field.ColumnName}}" matInput id='inp{{field.ColumnName}}' type='number'
              name='{{field.ColumnName}}' [(ngModel)]='dataDef[field.ColumnName]' min="{{field.MinLength}}"
              max="{{field.MaxLength}}" [required]="field.Required" />
          </tyl-form-field>

          <!-- Textboxes (Text only)-->
          <tyl-form-field [label]='field.DisplayName' [errorMessage]="getErrorMessage(field.ColumnName)"
            [fullWidth]='true' *ngSwitchCase="'textbox'">
            <input #input formControlName="{{field.ColumnName}}" matInput id='inp{{field.ColumnName}}' type='text'
              name='{{field.ColumnName}}' [(ngModel)]='dataDef[field.ColumnName]' minlength='{{field.MinLength}}'
              maxlength='{{field.MaxLength}}' [required]="field.Required" />
          </tyl-form-field>

          <!-- Checkboxes -->
          <tyl-checkbox *ngSwitchCase="'checkbox'" id='chk{{field.ColumnName}}' [(checked)]="dataDef[field.ColumnName]"
            [disabled]='!field.Editable || viewOnly'>
            <span translate>{{field.DisplayName}}</span>
          </tyl-checkbox>

          <!-- Dropdowns -->
          <tyl-form-field [label]='field.DisplayName' [fullWidth]='true' *ngSwitchCase="'dropdown'">
            <mat-select #select formControlName="{{field.ColumnName}}" [(ngModel)]="dataDef[field.ColumnName]"
              id="ddl{{field.ColumnName}}" [required]="field.Required">
              <mat-option *ngFor="let row of getDataSource(field.ColumnName)" [value]="row.Id">
                {{ row.Code }} - {{ row.Description }}
              </mat-option>
            </mat-select>
          </tyl-form-field>
        </div>
      </ng-container>
    </form>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <div class='flex-footer-right'>
    <error-prompt [errorList]="errors"></error-prompt>
    <tyl-button image="save.png" label="Save" (clickEvent)="saveClick()" [disabled]="viewOnly"></tyl-button>
    <tyl-button image="cancel.png" label="Cancel" (clickEvent)="cancelClick()"></tyl-button>
  </div>
</mat-dialog-actions>